import React, {Fragment, useEffect, useState} from "react";
import styled from "styled-components";

import Language from "@material-ui/icons/Language";
import Person from "@material-ui/icons/Person";
import ExitToApp from "@material-ui/icons/ExitToApp";
import MapIcon from '@material-ui/icons/Room';
import MenuIcon from '@material-ui/icons/Menu';

import { InertiaLink, usePage } from "@inertiajs/inertia-react";
import { Box, Container, Popover } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { Inertia } from "@inertiajs/inertia";
import Alert from "@material-ui/lab/Alert";
import { Trans } from "../../utils/i18n";
import { useLanguageSwitch } from "../../hooks/useLanguageSwitch";
import Cookies from "js-cookie";
import LanguageModal from "../LanguageModal";
import {getFlagEmoji} from "../../utils/getFlagEmoji";
import classNames from "classnames";
import {Transition} from "@headlessui/react";
import {Cookie} from "@mui/icons-material";
import {Button} from "@mui/material";
import {ArrowRightIcon} from "@material-ui/pickers/_shared/icons/ArrowRightIcon";
import ClientSwitcher from "../ClientSwitcher";

const Nav = styled.nav`
    width: 100%;
    background-color: ${(props) => props.color || props.theme.primary};
    padding: 1.5rem 1rem;
    font-size: 30px;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    position: relative;
    z-index: 1;
`;

const Left = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    padding: 10px;
    flex-wrap: wrap;
`;

const Right = styled.div`
    display: flex;
    align-items: center;
`;

const Logo = styled.img`
    width: auto;
    height: 2rem;
    margin-right: 10px;
`;

const FlashMessage = styled(Alert)`
    margin-top: 30px;
`;

const StyledLanguage = styled(Language)`
    cursor: pointer;
`;

const PopoverContent = styled.div`
    padding: 0 20px;
    border-radius: 10px;
`;

const LanguageSelect = styled.p`
    cursor: pointer;
    color: ${(props) => props.theme.primary};
`;

export default function B2XCarbonLayout({ children, wrapperStyle }) {
    const {
        props: { flash, user, languages },
    } = usePage();
    const { updateLanguage } = useLanguageSwitch();

    const handleLogoutClick = async () => {
        Inertia.post(route("logout"));
    };

    const [langSwitchElement, setLangSwitchElement] = useState();

    const handleLangClick = (event) => {
        setLangSwitchElement(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setLangSwitchElement(null);
    };

    const handleLanguageChange = (language) => {
        setLangSwitchElement(null);
        updateLanguage(language);
    };

    const open = Boolean(langSwitchElement);

    return (
        <div className={'flex min-h-screen flex-col font-titillium'}>
            <Nav color={"" || children.props.client.brand_color_header}>
                <Container maxWidth="lg">
                    <Grid container spacing={3}>
                        <Left>
                            <InertiaLink href={route("home")}>
                                {children.props.client.brand_logo && (
                                    <Logo
                                        src={children.props.client.brand_logo}
                                    />
                                )}
                            </InertiaLink>
                        </Left>
                        <Right>
                            {
                                languages.length > 1 &&
                                <>
                                    <StyledLanguage
                                        style={{
                                            color: children.props.client
                                                .brand_color_header_icons,
                                        }}
                                        onClick={handleLangClick}
                                    />
                                    <Popover
                                        id={open ? "language-popover" : undefined}
                                        open={open}
                                        anchorEl={langSwitchElement}
                                        onClose={handlePopoverClose}
                                        anchorOrigin={{
                                            vertical: "bottom",
                                            horizontal: "center",
                                        }}
                                        transformOrigin={{
                                            vertical: "top",
                                            horizontal: "center",
                                        }}
                                    >
                                        <PopoverContent>
                                            {languages.map((item) => (
                                                <LanguageSelect
                                                    onClick={() =>
                                                        handleLanguageChange(item.code)
                                                    }
                                                    key={item.code}
                                                >
                                                    { item.name }
                                                </LanguageSelect>
                                            ))}
                                        </PopoverContent>
                                    </Popover>
                                </>
                            }
                            {children.props.user?.id && (
                                <>
                                    <Button color={'white'} component={InertiaLink} href={route('dashboard')}>
                                        Dashboard
                                    </Button>
                                </>
                            )}
                            <ClientSwitcher />
                            {children.props.user?.id && (
                                <InertiaLink
                                    href={route("profile")}
                                    style={{ lineHeight: 0 }}
                                >
                                    <Person
                                        style={{
                                            color: children.props.client
                                                .brand_color_header_icons,
                                        }}
                                    />
                                </InertiaLink>
                            )}
                            {children.props.user?.id && (
                                <ExitToApp
                                    onClick={handleLogoutClick}
                                    style={{
                                        color: children.props.client
                                            .brand_color_header_icons,
                                        cursor: "pointer",
                                    }}
                                />
                            )}
                            {!children.props.user?.id && (
                                <>
                                    <Button color={'white'} component={InertiaLink} href={route('login')}>
                                        Log in
                                    </Button>
                                    <Button
                                        color={'primary'}
                                        variant={'contained'}
                                        sx={{
                                            backgroundColor: 'black',
                                        }}
                                        endIcon={<ArrowRightIcon />}
                                        component={'a'}
                                        href={'https://www.b2x.com/demo'}
                                        target={'_blank'}
                                    >
                                        <Trans i18nKey={'carbon.getInTouch'}>
                                            Get in touch
                                        </Trans>
                                    </Button>
                            </>
                        )}
                        </Right>
                    </Grid>
                </Container>
            </Nav>
            <Container maxWidth="lg">
                {flash.message && (
                    <FlashMessage severity="warning">
                        {flash.message}
                    </FlashMessage>
                )}
                {flash.status && (
                    <FlashMessage severity="success">
                        {flash.status}
                    </FlashMessage>
                )}
            </Container>
            <div className={'flex-1 flex flex-col pt-12 '} style={wrapperStyle}>
                {children}
            </div>

            <footer className="flex relative py-20 leading-6 text-left text-black scroll-smooth bg-[#415065]">
                <Container maxWidth="lg">
                    <div className={'flex justify-between pb-8'}>
                        <a href={'https://b2x.com'} target={'_blank'} rel="noopener">
                            <svg width="105" height="32" viewBox="0 0 105 32" fill="none" xmlns="http://www.w3.org/2000/svg"
                                 className="max-w-full h-auto leading-6 text-left text-white align-bottom border-0 border-none scroll-smooth"
                            >
                                <path d="M27.1855 9.92305C26.8201 11.9598 25.4078 12.6807 24.4318 12.9613C24.1011 13.0565 23.7995 13.099 23.3038 13.142H13.9201L13.3353 18.8016L22.7231 18.8096C23.1302 18.8096 23.5337 18.8926 23.9001 19.0659C24.822 19.5019 26.2243 20.5913 25.1921 23.1111C25.1921 23.1111 24.1819 25.3438 21.6829 25.7074C19.1838 26.0708 7.48666 25.7074 7.48666 25.7074L10.1983 6.1321C10.1983 6.1321 23.5381 6.11895 24.0834 6.12737C25.4827 6.14896 27.6484 7.34464 27.1855 9.92305ZM28.1165 16.6727C28.1165 16.6727 31.5724 14.44 32.4762 12.6225C33.348 10.87 35.8021 4.38514 27.3922 1.08463C26.7987 0.851533 26.1649 0.725942 25.5252 0.710526L5.09389 0.212891L0.361816 31.6266H22.2146C22.2146 31.6266 29.4987 31.2632 30.9344 25.915C32.3699 20.5668 30.4028 18.5938 28.1165 16.6727Z" fill="white"/>
                                <path d="M79.904 19.2688C79.7445 19.2688 89.6873 31.6266 89.6873 31.6266H97.6627L84.6893 15.686L104.362 0.212891H94.6321L81.0206 10.7535L72.6729 0.212891H64.7507L75.9162 14.5438L61.8263 25.869L43.6422 25.6034C43.6422 25.6034 57.307 14.6996 59.9654 12.8303C62.6238 10.9611 62.9961 7.94957 62.9961 7.94957C63.5684 3.13951 60.3285 0.96623 58.5255 0.508882C58.0662 0.392541 57.5924 0.339715 57.1176 0.340742L46.0706 0.362942C45.9687 0.364381 45.3307 0.417001 45.208 0.441051C37.613 1.92944 37.8468 8.52059 37.8468 8.52059H43.8018C44.2272 5.9765 46.3009 6.08606 46.3009 6.08606H54.6484C54.6484 6.08606 55.8202 6.25995 56.0294 7.00014C56.3832 8.25132 55.0205 8.936 55.0205 8.936C55.0205 8.936 47.1514 15.2706 40.5585 20.3113C33.9655 25.3518 34.1249 31.6266 34.1249 31.6266H63.8467C63.8467 31.6266 80.0636 19.2688 79.904 19.2688Z" fill="white"/>
                            </svg>
                        </a>
                        <div className="flex gap-3 leading-6 text-left text-white scroll-smooth">
                            <a
                                href="https://www.linkedin.com/company/b2x-care-solutions"
                                target="_blank"
                                rel="noopener"
                                className="text-base font-normal text-left bg-transparent cursor-pointer scroll-smooth text-[#677383] hover:text-gray-700"
                            >
                                <svg width="39" height="39" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="19.3281" cy="19.2129" r="19" fill="currentColor"/>
                                    <g clipPath="url(#clip0_294_1018)">
                                        <path d="M26.1781 11.2129H12.5081C11.8681 11.2129 11.3281 11.7329 11.3281 12.3829V26.3029C11.3281 26.9529 11.8681 27.4829 12.5081 27.4729H26.1781C26.8281 27.4729 27.3581 26.9529 27.3681 26.3029V12.3829C27.3581 11.7329 26.8281 11.2129 26.1781 11.2129ZM16.0881 25.0729H13.7081V17.3129H16.0881V25.0729ZM14.8981 16.2529C14.1381 16.2529 13.5181 15.6229 13.5181 14.8529C13.5181 14.0829 14.1381 13.4529 14.8981 13.4529C15.6581 13.4529 16.2781 14.0829 16.2781 14.8529C16.2781 15.6229 15.6581 16.2529 14.8981 16.2529ZM24.9981 25.0729H22.6181V21.3029C22.6181 20.4029 22.5981 19.2429 21.3781 19.2429C20.1581 19.2429 19.9481 20.2229 19.9481 21.2329V25.0729H17.5681V17.3129H19.8481V18.3729H19.8781C20.3381 17.5629 21.2081 17.0829 22.1281 17.1229C24.5381 17.1229 24.9781 18.7329 24.9781 20.8229V25.0829L24.9981 25.0729Z" fill="white"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_294_1018">
                                            <rect width="16.04" height="16.26" fill="white" transform="translate(11.3281 11.2129)"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                            </a>

                            <a
                                href="https://www.youtube.com/user/B2X"
                                target="_blank"
                                rel="noopener"
                                className="text-base font-normal text-left bg-transparent cursor-pointer scroll-smooth  text-[#677383] hover:text-gray-700"
                            >
                                <svg width="39" height="39" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="19.3281" cy="19.2129" r="19" fill="currentColor"/>
                                    <path d="M16.8893 21.75V16.6831L21.8526 19.2202L16.8893 21.7572V21.75ZM27.9326 15.0865C27.7155 14.3502 27.0718 13.767 26.2498 13.5701C24.7685 13.2129 18.8281 13.2129 18.8281 13.2129C18.8281 13.2129 12.8877 13.2129 11.4065 13.5701C10.5845 13.767 9.94078 14.3502 9.72364 15.0865C9.32812 16.4207 9.32812 19.2129 9.32812 19.2129C9.32812 19.2129 9.32812 22.0051 9.72364 23.3393C9.94078 24.0756 10.5845 24.6588 11.4065 24.8557C12.8877 25.2129 18.8281 25.2129 18.8281 25.2129C18.8281 25.2129 24.7685 25.2129 26.2498 24.8557C27.064 24.6588 27.7077 24.0756 27.9326 23.3393C28.3281 21.9978 28.3281 19.2129 28.3281 19.2129C28.3281 19.2129 28.3281 16.4207 27.9326 15.0865Z" fill="white"/>
                                </svg>
                            </a>

                            <a
                                href="https://www.instagram.com/b2xcaresolutions/"
                                target="_blank"
                                rel="noopener"
                                className="text-base font-normal text-left bg-transparent cursor-pointer scroll-smooth text-[#677383] hover:text-gray-700"
                            >
                                <svg width="39" height="39" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="19.3281" cy="19.2129" r="19" fill="currentColor"/>
                                    <g clipPath="url(#clip0_294_1023)">
                                        <path d="M18.3232 11.2129C16.1508 11.2129 15.883 11.2228 15.0299 11.2625C13.79 11.322 12.5699 11.6593 11.6672 12.5619C10.7646 13.4646 10.4372 14.6748 10.3777 15.9147C10.338 16.7678 10.3281 17.0356 10.3281 19.2079C10.3281 21.3803 10.3281 21.6481 10.3777 22.5012C10.4372 23.7411 10.7844 24.9711 11.6772 25.8639C12.5699 26.7566 13.7999 27.1038 15.0398 27.1633C15.8929 27.203 16.1607 27.2129 18.3331 27.2129C20.5054 27.2129 20.7733 27.2129 21.6263 27.1633C22.8663 27.1038 24.0963 26.7665 24.989 25.8639C25.8818 24.9711 26.2289 23.7411 26.2884 22.5012C26.3281 21.6481 26.338 21.3803 26.338 19.2079C26.338 17.0356 26.338 16.7678 26.2884 15.9147C26.2289 14.6748 25.8917 13.4448 24.989 12.552C24.0863 11.6593 22.8563 11.322 21.6263 11.2625C20.7733 11.2228 20.5054 11.2129 18.3331 11.2129M18.3331 12.6512C20.4658 12.6512 20.7237 12.6512 21.5668 12.7008C22.4397 12.7405 23.3325 12.9389 23.9673 13.5737C24.6121 14.2185 24.8005 15.1013 24.8402 15.9742C24.8799 16.8174 24.8898 17.0753 24.8898 19.2079C24.8898 21.3406 24.8898 21.5985 24.8402 22.4417C24.8005 23.3046 24.5922 24.2172 23.9673 24.8422C23.3225 25.4869 22.4397 25.6754 21.5668 25.7151C20.7237 25.7547 20.4658 25.7647 18.3331 25.7647C16.2004 25.7647 15.9425 25.7647 15.0994 25.7151C14.2364 25.6754 13.3238 25.4671 12.6989 24.8422C12.064 24.2073 11.8656 23.3046 11.826 22.4417C11.7863 21.5985 11.7764 21.3406 11.7764 19.2079C11.7764 17.0753 11.7764 16.8174 11.826 15.9742C11.8656 15.1112 12.0739 14.1986 12.6989 13.5737C13.3337 12.9289 14.2265 12.7405 15.0994 12.7008C15.9425 12.6611 16.2004 12.6512 18.3331 12.6512Z" fill="white"/>
                                        <path d="M18.3234 21.8765C16.8554 21.8765 15.6551 20.6862 15.6551 19.2082C15.6551 17.7302 16.8454 16.5399 18.3234 16.5399C19.8014 16.5399 20.9918 17.7302 20.9918 19.2082C20.9918 20.6862 19.8014 21.8765 18.3234 21.8765ZM18.3234 15.1016C16.0519 15.1016 14.2168 16.9367 14.2168 19.2082C14.2168 21.4797 16.0519 23.3148 18.3234 23.3148C20.595 23.3148 22.4301 21.4797 22.4301 19.2082C22.4301 16.9367 20.595 15.1016 18.3234 15.1016Z" fill="white"/>
                                        <path d="M22.5989 13.9805C23.1246 13.9805 23.5611 14.407 23.5611 14.9427C23.5611 15.4783 23.1345 15.9048 22.5989 15.9048C22.0633 15.9048 21.6367 15.4783 21.6367 14.9427C21.6367 14.407 22.0633 13.9805 22.5989 13.9805Z" fill="white"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_294_1023">
                                            <rect width="16" height="16" fill="white" transform="translate(10.3281 11.2129)"/>
                                        </clipPath>
                                    </defs>
                                </svg>

                            </a>
                        </div>
                    </div>
                    <div className="flex flex-col justify-start mx-auto sm:flex-row py-8 border-y border-white gap-6">
                        {
                            [
                                {
                                    title: 'Solutions',
                                    items: [
                                        {
                                            href: "https://b2x.com/solutions/hardware-lifecycle-solutions",
                                            role: "menuitem",
                                            target: "_self",
                                            className: "text-base font-normal leading-6 text-left text-white bg-transparent cursor-pointer",
                                            text: "Hardware Lifecycle Solutions",
                                        },
                                        {
                                            href: "https://b2x.com/solutions/digital-platform-services",
                                            role: "menuitem",
                                            target: "_self",
                                            className: "text-base font-normal leading-6 text-left text-white bg-transparent cursor-pointer scroll-smooth",
                                            text: "Digital Platform Services",
                                        },
                                        {
                                            href: "https://b2x.com/solutions/carbon-impact-management",
                                            role: "menuitem",
                                            target: "_self",
                                            className: "text-base font-normal leading-6 text-left text-white bg-transparent cursor-pointer scroll-smooth",
                                            text: "Carbon Impact Management",
                                        },
                                    ],
                                },
                                {
                                    title: 'Why B2X',
                                    items: [
                                        {
                                            href: "https://b2x.com/why-b2x",
                                            role: "menuitem",
                                            target: "_self",
                                            className: "text-base font-normal leading-6 text-left text-white bg-transparent cursor-pointer scroll-smooth",
                                            text: "Value Proposition",
                                        },
                                        {
                                            href: "https://b2x.com/why-b2x/digital-platform",
                                            role: "menuitem",
                                            target: "_self",
                                            className: "text-base font-normal leading-6 text-left text-white bg-transparent cursor-pointer scroll-smooth",
                                            text: "Digital Platform",
                                        },
                                        {
                                            href: "https://b2x.com/industries",
                                            role: "menuitem",
                                            target: "_self",
                                            className: "text-base font-normal leading-6 text-left text-white bg-transparent cursor-pointer scroll-smooth",
                                            text: "Industry Expertise",
                                        },
                                    ],
                                },
                                {
                                    title: 'Company',
                                    items: [
                                        {
                                            href: "https://b2x.com/about-us",
                                            role: "menuitem",
                                            target: "_self",
                                            className: "text-base font-normal leading-6 text-left text-white bg-transparent cursor-pointer scroll-smooth",
                                            text: "About Us",
                                        },
                                        {
                                            href: "https://b2x.com/about-us/sustainability",
                                            role: "menuitem",
                                            target: "_self",
                                            className: "text-base font-normal leading-6 text-left text-white bg-transparent cursor-pointer scroll-smooth",
                                            text: "Sustainability",
                                        },
                                        {
                                            href: "https://b2x.com/about-us/careers",
                                            role: "menuitem",
                                            target: "_self",
                                            className: "text-base font-normal leading-6 text-left text-white bg-transparent cursor-pointer scroll-smooth",
                                            text: "Careers",
                                        },
                                    ],
                                },
                                {
                                    title: 'Legal',
                                    items: [
                                        {
                                            href: "https://b2x.com/legal-notice",
                                            role: "menuitem",
                                            target: "_self",
                                            className: "text-base font-normal leading-6 text-left text-white bg-transparent cursor-pointer scroll-smooth",
                                            text: "Legal Notice",
                                        },
                                        {
                                            href: "https://b2x.com/privacy-policy",
                                            role: "menuitem",
                                            target: "_self",
                                            className: "text-base font-normal leading-6 text-left text-white bg-transparent cursor-pointer scroll-smooth",
                                            text: "Privacy Policy",
                                        },
                                        {
                                            href: "https://b2x.com/demo",
                                            role: "menuitem",
                                            target: "_self",
                                            className: "text-base font-normal leading-6 text-left text-white bg-transparent cursor-pointer scroll-smooth",
                                            text: "Contact",
                                        },
                                    ],
                                },
                            ]
                                .map((item) => (
                                    <div className="flex flex-col mr-4 sm:mr-16 sm:mb-4" key={item.title}>
                                        <p className="mt-2 mb-3 text-base font-semibold leading-6 text-left text-white scroll-smooth">
                                            { item.title }
                                        </p>
                                        {
                                            item.items.map((link) => <a
                                                href={link.href}
                                                role={link.role}
                                                target={link.target}
                                                className={'text-base no-underline hover:underline font-normal mt-2 leading-6 text-left text-white bg-transparent cursor-pointer scroll-smooth'}
                                                key={link.text}
                                            >
                                                {link.text}
                                            </a>)
                                        }
                                    </div>
                                ))
                        }
                    </div>

                    <p className="mt-3 text-sm font-normal leading-5 text-left text-white scroll-smooth">
                        Copyright © 2024 B2X Care Solutions GmbH. All rights reserved.
                    </p>
                </Container>
            </footer>
        </div>
    );
}
